module.exports = __webpack_public_path__ + "58713b566cfe62d71c5f04b13662c77b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/arabesque_asset_management.png
// module id = 1612
// module chunks = 0